import { authorize, deleteRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const backendURL = `${AWS_API_URL}/user/rss-feeds`;

export async function deleteRSSFeedAPI(id) {
  return deleteRequest(`${backendURL}/${id}`, await authorize());
}
